import { isNoSystemFolder, isSystemFolder } from '../../../utils/file'

export function isFolder(item) {
  return isSystemFolder(item) || isNoSystemFolder(item)
}
